module.exports = __webpack_public_path__ + "img/Plinth.1381e35d.jpg";